import script from "./dietary-information-section.vue?vue&type=script&setup=true&lang=js"
export * from "./dietary-information-section.vue?vue&type=script&setup=true&lang=js"

import "./dietary-information-section.vue?vue&type=style&index=0&id=0e3c8a71&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3c8a71"]])

export default __exports__